import { create } from 'zustand';

interface SettingsState {
  /** When true, all animations are disabled regardless of OS setting. */
  reduceMotion: boolean;
  setReduceMotion: (value: boolean) => void;
}

export const useSettingsStore = create<SettingsState>((set) => ({
  reduceMotion: false,
  setReduceMotion: (value) => set({ reduceMotion: value }),
}));
